import { render, staticRenderFns } from "./PageLegalInformation.vue?vue&type=template&id=36137838&scoped=true&"
import script from "./PageLegalInformation.vue?vue&type=script&lang=js&"
export * from "./PageLegalInformation.vue?vue&type=script&lang=js&"
import style0 from "./PageLegalInformation.vue?vue&type=style&index=0&id=36137838&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36137838",
  null
  
)

export default component.exports